/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
// import _ from 'lodash';

import {
  REQUEST_TRANSPORTERS,
  SET_NEW_TRANSPORTER_VALUE,
  INITIATE_TRANSPORTER_EDIT,
  INITIATE_TRANSPORTER_CREATE,
  UPDATE_TRANSPORTER_SEARCH_STRING,
  UPDATE_TRANSPORTER_FILTERS,
  REQUEST_TRANSPORTER_FILTER,
  REQUEST_TRANSPORTER_FILTER_RESET,
  REQUEST_TRANSPORTER,
  TRANSPORTER_FIELD_TYPES,
} from './constants';

import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { fixPriceFormat } from '../../utils/string';
import env from '../../env';
import { AppClientId } from '../Shared/constants';

const DEFAULT_FILTER = {
  searchString: null,
  offset: 0,
  properties: [],
  sortType: null,
  order: null,
};

export const initialState = {
  filter: {
    ...DEFAULT_FILTER,
  },

  newTransporter: {},

  transporterCount: null,
  paginator: {},
  propertyNames: null,

  // Transporters
  transporters: [],
  transportersById: {},
};

export const transporterReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_NEW_TRANSPORTER_VALUE:
        if (action.initiate) {
          draft.newTransporter[action.name] = draft.newTransporter[action.name] || '';
        } else draft.newTransporter[action.name] = action.value;
        return;
      case INITIATE_TRANSPORTER_EDIT:
        try {
          draft.newTransporter = {
            id: action.id,
          };

          let transporter = draft.transportersById[action.id];

          if (transporter) {
            Object.keys(transporter)?.forEach(p => {
              if (['id', 'companyToRead', 'companyFromRead', 'vehicleRead']?.includes(p)) return null;

              draft.newTransporter[p] = transporter[p];
              return null;
            });
          }
        } catch (e) {
          // eslint-disable-next-line no-debugger
          console.log(e);
        }
        break;
      case INITIATE_TRANSPORTER_CREATE:
        //only clear if there's an id
        draft.newTransporter = {};
        TRANSPORTER_FIELD_TYPES?.forEach(p => {
          draft.newTransporter[p] = '';
        });

        break;

      case UPDATE_TRANSPORTER_SEARCH_STRING:
        draft.filter.searchString = action.searchString || '';
        return;
      case UPDATE_TRANSPORTER_FILTERS:
      case REQUEST_TRANSPORTER_FILTER:
        if ('propertyFilter' in action) {
          if (action?.options?.skipFilter) {
            draft.filter.properties = [];
            draft.filter.properties.push(action.propertyFilter);
            return;
          }
          draft.filter.properties = draft.filter.properties
            .map(p => {
              if (p.key == action.propertyFilter?.key) return null;
              if (p.key == action.reset) return null;
              if (action.reset?.indexOf?.(p.key) > -1) {
                return null;
              }
              return p;
            })
            .filter(p => p);

          if (action.propertyFilter) draft.filter.properties.push(action.propertyFilter);
        }

        //clear empty values
        draft.filter.properties = draft.filter.properties.filter(p => p.value.length || p.value.id);

        if (action.name) {
          draft.filter[action.name] = action.value;
          //reset offset
        }

        if (action.name !== 'offset') draft.filter.offset = 0;
        break;
      case REQUEST_TRANSPORTER_FILTER_RESET:
        draft.filter = {
          ...DEFAULT_FILTER,
        };
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_TRANSPORTERS:
            draft.transporters = action?.result?.items;

            draft.paginator = action.result.paginator;
            draft.transporterCount = action.result.paginator.itemsCount;
            draft.transporters.forEach(o => {
              // if (!draft.transportOrdersById[o.id])
              draft.transportersById[o.id] = o;
            });
            break;
          case REQUEST_TRANSPORTER:
            try {
              draft.transportersById[action.transporterId] = action?.result;
              console.dir(action.result);
            } catch (e) {
              console.error(e);
            }

            break;
        }
        break;
    }
  });
